import { CompanyUser } from '~/types/User';

export interface CompanyUserApi {
  postUserCsvUpload: (requestBody: File) => Promise<string|null>;
  getCompanyUserMe: () => Promise<CompanyUser | null>;
}

export const useCompanyUserApi = (fetch): CompanyUserApi => {
  /** 企業ユーザー一括登録用CSVのアップロード */
  const postUserCsvUpload = async (requestBody: File): Promise<string|null> => {
    const formData = new FormData();
    formData.append('file', requestBody);
    try {
      const response = await fetch('/company-user/upload', formData);
      return response.data;
    } catch (error) {
      console.error('Error uploading CSV:', error);
      return null;
    }
  };

  const getCompanyUserMe = async (): Promise<CompanyUser | null> => {
    try {
      const response = await fetch('/company-users/me');
      return response.data;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  return {
    postUserCsvUpload,
    getCompanyUserMe,
  };
};
